import { Col, Row } from 'antd';
import InventoryListComponent from '../../components/inventory-list/inventory-list.component';
import InventoryNavigationComponent from '../../components/navigation/inventory-navigation.component';

export default function InventoryPage() {
  return (
    <Row>
      <Col xs={24} sm={8} lg={6}>
        <InventoryNavigationComponent />
      </Col>
      <Col xs={24} sm={16} lg={18}>
        <InventoryListComponent />
      </Col>
    </Row>
  );
}
